import { useTranslation } from 'react-i18next';

export default function WhyUs() {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-database-2-line',
      title: t('home:whyUs1Title'),
      desc: t('home:whyUs1Desc'),
    },
    {
      icon: 'ri-hd-line',
      title: t('home:whyUs2Title'),
      desc: t('home:whyUs2Desc'),
    },
    {
      icon: 'ri-vip-crown-line',
      title: t('home:whyUs3Title'),
      desc: t('home:whyUs3Desc'),
    },
    {
      icon: 'ri-timer-flash-line',
      title: t('home:whyUs4Title'),
      desc: t('home:whyUs4Desc'),
    },
  ];

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-3">
            {t('home:whyUsTitle')}
          </h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
            {t('home:featuredDesc')}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-6 text-center transition-all hover:scale-[1.02]"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-accent-100 rounded-full">
                <i className={`${feat.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}